import { Link } from "react-router-dom";
import Seo from "../components/Seo.jsx";
import { Icon } from "../components/Icons.jsx";

export default function NotFound() {
  return (
    <>
      <Seo title="Page not found · Simple Meditation World" description="" path="/" />
      <section className="section-night" style={{ paddingTop: 120, paddingBottom: 120, minHeight: "60vh" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <div style={{ color: "var(--gold)", fontFamily: "var(--mono)", letterSpacing: "0.22em", textTransform: "uppercase", fontSize: 12 }}>404 · Lost the way</div>
          <h1 style={{ color: "var(--ivory)", fontFamily: "var(--serif)", fontWeight: 400, fontSize: "clamp(40px, 6vw, 72px)", marginTop: 18 }}>
            This <em style={{ color: "var(--gold)", fontStyle: "italic" }}>doorway</em> doesn't exist.
          </h1>
          <p style={{ color: "rgba(248,241,231,0.7)", maxWidth: 500, margin: "20px auto" }}>
            The page you're looking for isn't here. There are still 112 others.
          </p>
          <Link to="/techniques" className="btn btn-primary" style={{ marginTop: 24 }}>
            Browse All 112 {Icon.arrowSm()}
          </Link>
        </div>
      </section>
    </>
  );
}
